import { Box2, Vector2 } from "three";
import { DOMHitTest } from "../../../library-js/dom-tools/DOMHitTest";
import { ElementType } from "../../../library-js/dom-tools/ElementType";
import { HTMLEditor } from "../../../library-js/dom-tools/HTMLEditor";
import { isClassOf } from "../../../library-js/tools/TypeUtilities";
import { NodeGraph } from "../model/NodeGraph";
import { NodeGraphComponent } from "../model/NodeGraphComponent";
import { NodeGraphNode } from "../model/NodeGraphNode";
import { NodeGraphReference } from "../model/NodeGraphReference";
import { NodeGraphSelection } from "../model/NodeGraphSelection";
import { NodeGraphController } from "./NodeGraphController";
import { ElementWithNodeGraphReference, NodeGraphEvent } from "./NodeGraphEvent";
import { NodeGraphInteraction } from "./NodeGraphInteraction";

export class NGSelector extends NodeGraphInteraction
{
  _rectSelection:boolean;
  _replaceMode:boolean;
  _selectionStart:Vector2;
  _selectionEnd:Vector2;
  _cachedSelection:NodeGraphSelection;
  _waitingForMovement:boolean;
  _waitingForMovementStartTime:number = 0;
  _mouseReleased:boolean = false;

  constructor( ng:NodeGraph )
  {
    super( ng );
  }



  update( nge:NodeGraphEvent )
  {
    if ( this._rectSelection )
    {
      this.updateRectSelection( nge );
      return;
    }    
    
    if ( ! nge.mouse.buttons[ 0 ].isDown )
    {
      return;
    }   


    let hoveredReference = nge.hoveredReference;
    let selection = this._nodeGraph._selection;

    let selected:NodeGraphReference[] = [];

    if ( ! hoveredReference )
    {
      let edge = this._nodeGraph.getClosestEdge( nge.localMousePosition );

      if ( edge )
      {  
        selected = [ edge ];
      }      
    }
    else
    {
      selected = [ hoveredReference.reference ];      
    }

    this._replaceMode = ! ( nge.shiftKey.isHold || nge.ctrlKey.isHold );

    let wasEmpty = selection.isEmpty;


    selection.set( selected, this._replaceMode );    
    selection.apply();

    let isEmpty = selection.isEmpty;

    if ( selected.length == 0 && ( wasEmpty && isEmpty ) )
    {
      this._rectSelection = true;
      this._nodeGraph._controller.focus( this );

      this._selectionStart = nge.localMousePosition.clone();
      this._selectionEnd   = nge.localMousePosition.clone();
      this._cachedSelection = this._nodeGraph._selection.clone();
      this._waitingForMovement = true;
      this._waitingForMovementStartTime = new Date().getTime();
      this._mouseReleased = false;
    }
  }

  updateRectSelection( nge:NodeGraphEvent )
  {
    if ( this._waitingForMovement )
    {
      let distance = nge.localMousePosition.distanceTo( this._selectionStart );

      if ( distance > 2 )
      {
        this._waitingForMovement = false;
      }
      else
      {
        let elapsed = ( new Date().getTime() ) - this._waitingForMovementStartTime;

        if ( elapsed > 400 )
        {
          if ( nge.mouse.buttons[ 0 ].isHold )
          {
            this._waitingForMovement = false;
          }
          else
          {
            this._waitingForMovement = false;
            this._rectSelection = false;
            console.log( "clearing" );
          }
          
        }

        return;
      }

      
    }

    if ( nge.mouse.buttons[ 0 ].isDown || ( ! this._mouseReleased && nge.mouse.buttons[ 0 ].isUp ) )
    {
      this._nodeGraph._controller.blur();
      this._nodeGraph._ui._overlaysLayer.selectionRect.value = false;
      this._nodeGraph._ui._overlaysLayer.redraw();

      this._rectSelection = false;
      return;
    }   

    this._selectionEnd = nge.localMousePosition.clone();    
    let overlaysLayer = this._nodeGraph._ui._overlaysLayer;
    
    overlaysLayer.selectionRect.value = true;

    overlaysLayer.selectionStart.value.copy( this._selectionStart ).min( this._selectionEnd );
    overlaysLayer.selectionEnd.value.copy( this._selectionStart ).max( this._selectionEnd );

    let insideBox:NodeGraphReference[] = [];
    
    let selectionBox = new Box2( overlaysLayer.selectionStart.value, overlaysLayer.selectionEnd.value );

    let edgesInside = this._nodeGraph.getEdgesInsideBox( selectionBox );
    insideBox = insideBox.concat( edgesInside );
    
    let nodesInside = this._nodeGraph.getNodesInsideBox( selectionBox );
    insideBox = insideBox.concat( nodesInside )

    let insideIDs = insideBox.map( i => i._id );
    let selectedSet = new Set<string>( [ ...this._cachedSelection._set, ...insideIDs ] );

    
    

    this._nodeGraph._ui._overlaysLayer.redraw();

    let selection = this._nodeGraph._selection;

    selection.setByID( Array.from( selectedSet ), this._replaceMode );    
    selection.apply();


  }

}